/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { SVGProps } from 'react';

export function NmCartIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 20.5 23.6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.6,5.7C5.6,3.1,7.7,1,10.2,1s4.7,2.1,4.7,4.7H5.6z M4.6,5.7C4.6,2.5,7.1,0,10.2,0c3.1,0,5.7,2.5,5.7,5.7h4.1c0.3,0,0.5,0.2,0.5,0.5v16.9c0,0.3-0.2,0.5-0.5,0.5H0.5c-0.3,0-0.5-0.2-0.5-0.5V6.2c0-0.3,0.2-0.5,0.5-0.5H4.6z M1,6.7h18.5v15.9H1V6.7z"
                fill="currentColor"
            />
        </svg>
    );
}
